import React, { Component, ErrorInfo, ReactNode } from 'react';
import IconButton from '../../ui/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ChunkLoadErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    if (error.message.includes("Failed to fetch dynamically imported module") || 
        error.message.includes("Loading chunk") ||
        error.name === 'ChunkLoadError') {
      return { hasError: true };
    }
    throw error;
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    if (this.state.hasError) {
      console.error("Caught a chunk load error:", error, errorInfo);
    }
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h2>A new version has been released.</h2>
            <p>Press the button below to refresh</p>
            <IconButton name='detail-screen-refresh' data-tooltip='Refresh' onClick={() => window.location.reload()}>
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </IconButton>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;